import React, { useMemo } from 'react';
import {
  Button,
  Checkbox,
  Dropdown,
  List,
  Radio,
  SearchBox,
  StatusTip,
} from 'tea-component';
import { useIntl } from 'umi';
import BubbleCommon from '../../../BubbleCommon';
import { NO_DATE } from '@/pages/opinion/constants';
import { getPlaceholderText } from '../../constants/placeholder';
import './index.scss';
import { addFilterBuriedPoint } from '../../utils/point';
import { escapeAllTags } from '@op/utils/text';

export default function CommonAllSelect({
  keyword,
  onSearchValueChange,
  onSearch,
  searchPlaceholder = NO_DATE.EMPTY,
  onSearchClear,

  leftText = NO_DATE.EMPTY,
  loadingText = NO_DATE.EMPTY,
  topTips = NO_DATE.EMPTY,

  loading = false,

  allRadioClick,
  value = [],
  allRadioTips,

  options = [],
  changeAllSelected,
  changeValues,
  getRenderText = (text: string) => text,
  getButtonElement,

  placeholderKey,
  overlayClassName,
  boxClassName,
  pointKey,
  ...otherDropdownProps
}: any) {
  const footerElement = useMemo(() => {
    if (loading) {
      return 'loading';
    }
    if (options.length === 0) {
      return 'empty';
    }

    return false;
  }, [loading, options]);

  const { formatMessage } = useIntl();

  const isAllSelected = useMemo(() => {
    return options.every((item: { value: string }) =>
      value.includes(item.value),
    );
  }, [value, options]);

  return (
    <div className="common-all-select-wrapper">
      <Dropdown
        placement="bottom-start"
        overlayClassName={`dbo-all-select-overlay ${overlayClassName}`}
        boxClassName={`dbo-all-select-box ${boxClassName}`}
        clickClose={false}
        appearance="button"
        onClose={() => {
          addFilterBuriedPoint(pointKey);
        }}
        button={
          <div className="dbo-all-select-text">
            <span className="dbo-all-select-label">
              {getPlaceholderText(placeholderKey)}
            </span>
            {getButtonElement()}
          </div>
        }
        {...otherDropdownProps}
      >
        <SearchBox
          className="dbo-search-input-info"
          value={keyword}
          onChange={onSearchValueChange}
          onSearch={onSearch}
          onClear={onSearchClear}
          placeholder={formatMessage({ id: searchPlaceholder })}
        />

        {footerElement ? (
          <StatusTip
            className="loading-text"
            loadingText={formatMessage({ id: loadingText })}
            status={footerElement}
          />
        ) : (
          <>
            {topTips && (
              <div className="top-tips">{formatMessage({ id: topTips })}</div>
            )}

            <div className="radio-all-box">
              <Radio
                name="all"
                className="radio-item"
                onClick={allRadioClick}
                value={value.length === 0}
              >
                {formatMessage({ id: 'All' })}
                {allRadioTips && (
                  <BubbleCommon
                    placement="top"
                    tipsMap={allRadioTips}
                  ></BubbleCommon>
                )}
              </Radio>
            </div>
            <div className="title-box">
              <label className="label-title">
                {keyword
                  ? `${formatMessage({ id: 'Search Result' })} (${
                      options.length
                    })`
                  : formatMessage({ id: leftText })}
              </label>
              <Button
                onClick={() => changeAllSelected?.(isAllSelected)}
                type="link"
              >
                {formatMessage({
                  id: isAllSelected ? 'Clear All' : 'Select All',
                })}
              </Button>
            </div>
            <div className="dbo-list-box">
              <Checkbox.Group
                className="checkbox-group-box"
                value={value}
                onChange={changeValues}
              >
                <List type="option" className="select-list-box">
                  {options.map((item: { text: string; value: string }) => {
                    return (
                      <List.Item key={item.value} className="select-list-item">
                        <Checkbox className="check-box-item" name={item.value}>
                          {getRenderText(escapeAllTags(item.text), item.value)}
                        </Checkbox>
                      </List.Item>
                    );
                  })}
                </List>
              </Checkbox.Group>
            </div>
          </>
        )}
      </Dropdown>
    </div>
  );
}
